import BaseEnumType from "../../common/base-enum-type";

const MatchResultType = Object.freeze({
    Tie: new BaseEnumType("tie", "Tie"),
    Home: new BaseEnumType("home", "Home"),
    Away: new BaseEnumType("away", "Away")
});

export default MatchResultType;
